import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialValveClearance = {
  enabled: false,
  enabledValue: 8.0,
  disabledValue: 8.0,
  unit: 'mm',
};

const useValveStore = create(devtools((set, get) => ({
  // Kept for older saved UI state; placement now uses fields below.
  valve: initialValveClearance,

  selectedValveId: null,
  valveStatus: 'idle',
  valveReady: false,
  valvePlaced: false,
  valveApplied: false,
  valveApplyStatus: 'idle',
  valveApplyRequestId: 0,
  valveUndoRequestId: 0,
  valveError: null,

  // Socket-local descriptor of the applied valve hole ({ space, center, axis,
  // radius }); consumed by the locking step to block cuts that would collide
  // with it. Null until a valve hole is applied.
  valveHole: null,
  setValveHole: (valveHole) => set({ valveHole }),

  setValve: (data) => set({ valve: { ...get().valve, ...data } }),
  selectValve: (selectedValveId) =>
    set({
      selectedValveId,
      valveStatus: selectedValveId ? 'loading' : 'idle',
      valveReady: false,
      valvePlaced: false,
      valveApplied: false,
      valveApplyStatus: 'idle',
      valveUndoRequestId: 0,
      valveError: null,
    }),
  setValveStatus: (valveStatus, valveError = null) => set({ valveStatus, valveError }),
  setValveReady: (valveReady) => set({ valveReady }),
  setValvePlaced: (valvePlaced) => set({ valvePlaced, valveReady: valvePlaced }),
  requestApplyValve: () =>
    set((state) => ({
      valveApplyRequestId: state.valveApplyRequestId + 1,
      valveApplyStatus: 'applying',
      valveError: null,
    })),
  setValveApplied: (valveApplied) =>
    set({
      valveApplied,
      valveApplyStatus: valveApplied ? 'applied' : 'idle',
      valveReady: valveApplied,
      valveError: null,
    }),
  setValveApplyError: (valveError) =>
    set({
      valveApplyStatus: 'error',
      valveError,
    }),
  requestUndoValve: () =>
    set((state) => ({
      valveUndoRequestId: state.valveUndoRequestId + 1,
      valveApplyStatus: 'undoing',
      valveError: null,
    })),
  setValveUndone: () =>
    set({
      valveApplied: false,
      valveApplyStatus: 'idle',
      valvePlaced: false,
      valveReady: true,
      valveError: null,
      valveHole: null,
    }),
  resetPlacement: () =>
    set({
      selectedValveId: null,
      valveStatus: 'idle',
      valveReady: false,
      valvePlaced: false,
      valveApplied: false,
      valveApplyStatus: 'idle',
      valveUndoRequestId: 0,
      valveError: null,
    }),
  reset: () =>
    set({
      valve: initialValveClearance,
      selectedValveId: null,
      valveStatus: 'idle',
      valveReady: false,
      valvePlaced: false,
      valveApplied: false,
      valveApplyStatus: 'idle',
      valveApplyRequestId: 0,
      valveUndoRequestId: 0,
      valveError: null,
      valveHole: null,
    }),
})));

export default useValveStore;